export default {
  CATEGORY: {
    RENT_PAYMENT: 'rentPayment',
    ONE_TIME_PAYMENT: 'oneTimePayment',
    MOVE_IN_COSTS: 'moveInCosts',
    RENTAL_PROTECTION_DIRECT_DEBIT: 'rentalProtectionDirectDebit',
  },
  STATUS: {
    UNPAID: 'unpaid',
    PAST_DUE: 'pastDue',
    COMPLETE: 'complete',
    PENDING: 'pending',
    PAYMENT_FAILED: 'paymentFailed',
    DEPOSIT_FAILED: 'depositFailed',
    REFUNDED: 'refunded',
    DISPUTED: 'disputed',
    MANUAL: 'manual',
  },
  LEDGER_GROUP: {
    UPCOMING: 'upcoming',
    COMPLETED: 'completed',
    PAST_DUE: 'pastDue',
  },
};
